export const IconPhotoAddPhotoGrey: {
  name: 'icon_photo_add_photo_grey-42a9c7425114'
} = {
  name: 'icon_photo_add_photo_grey-42a9c7425114'
}
